import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import INSTA_ICON from 'shared/assets/images/insta_icon.png';
import FB_ICON from 'shared/assets/images/fb_icon.png';
import s from './SocialLinks.css';

class SocialLinks extends React.PureComponent {
  render() {
    const { advert: { instagram_link: instaLink = '', facebook_link: fbLink = '' } } = this.props;
    return (
      <div className={s.root}>
        {instaLink &&
          <a href={instaLink} target="_blank" rel="nofollow noopener noreferrer">
            <img src={INSTA_ICON} alt="" className={s.instaIcon} />
          </a>}
        {fbLink &&
          <a href={fbLink} target="_blank" rel="nofollow noopener noreferrer">
            <img src={FB_ICON} alt="" className={s.fbIcon} />
          </a>}
      </div>
    );
  }
}

SocialLinks.propTypes = {
  advert: PropTypes.shape(),
};

SocialLinks.defaultProps = {
  advert: {},
};
export default withStyles(s)(SocialLinks);



// WEBPACK FOOTER //
// ./src/shared/components/SocialLinks/SocialLinks.js